import { z } from "zod"

export const MAX_ORDER_ITEMS = 100

export const PURCHASE_ORDER_LIST = { limit: 200 }

export const newOrderSearchSchema = z.object({
  parts: z.preprocess(
    (value) =>
      Array.isArray(value) ? value : value === undefined ? undefined : [value],
    z.array(z.string().uuid()).max(MAX_ORDER_ITEMS).catch([]),
  ),
})
